import { html, TemplateResult } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { store } from '@src/store';
import { TOGGLE_MERGE_ACCEPTED } from '@src/store/consents';
import { MergeAccountsDetails } from '@src/types/common';

export const mergeAccountsWrapper = (mergeDetails: MergeAccountsDetails, innerHTML: TemplateResult[], granted = false) => html`
  <one-stack gap="md">
    <one-text as="p">
      <strong>
        ${unsafeHTML(mergeDetails.headerText)}
      </strong>
    </one-text>
    <one-paper background="legal-1" padding="sm" text-color="make-links-blau">
        ${innerHTML}
    </one-paper>
    <one-cluster gap="xxs" no-wrap>
      <one-checkbox
        id="mergeCheckbox"
        name="mergeCheckbox"
        type="checkbox"
        .checked=${granted}
        variant="outline"
        @change=${() => store.dispatch({ type: TOGGLE_MERGE_ACCEPTED })}
      ></one-checkbox>
      <one-content>
        <strong>
          ${unsafeHTML(mergeDetails.checkboxText)}
        </strong>
      </one-content>
    </one-cluster>
  </one-stack>`;
